import axios from 'axios';
import { _retrieveToken, CMServerErrorList, CM_INVALID_TOKEN, CM_EXPIRED_TOKEN } from './api.service';
import { CMError } from '@/models/cm-error.model';
import store from '@/store';

const ax = axios.create({
    // 'https://learning.codemotion.com/api',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + _retrieveToken(),
      },
});

interface CMResponse {
    data: any;
    errors: any;
    success: boolean;
}

export class LearningApi {

    public static async getUserEnrollments() {
        try {
            const res = await ax.get<CMResponse>(store.getters.conf.learning_api + '/me/courses');
            return res.data.data;
        } catch (e) {
            throw this._handleError(e);
        }
    }

    public static async getCourses() {
        try {
            const res = await ax.get(store.getters.conf.learning_bo_api + '/wp_query/args/?post_type=course&posts_per_page=6&meta_query[0][key]=status&meta_query[0][value]=closed&meta_query[0][compare]=!%3D');
            return res.data;
        } catch (e) {
            throw this._handleError(e);
            
        }
    }

    public static async getFilteredCoursesByIds(ids) {
        try {
            const res = await ax.get(store.getters.conf.learning_bo_api + '/wp/v2/course?include=' + ids + '&per_page=80');
            return res.data;
        } catch (e) {
            throw this._handleError(e);
        }
    }

    private static _handleError(error): CMServerErrorList | Error {
        if ( error.response ) {
            if (error.response.status === 401) {
                error = JSON.parse(JSON.stringify( error ));
                return new CMError('UnauthorizedRedirect', error.response.data.errors[0].message);
            }
            error = JSON.parse(JSON.stringify( error ));
            if (this._checkTokenDelete(error.response.data.errors)) {
                return new CMError('Unauthorized', 'Invalid or expired token');
            }
            return {
                errors: error.response.data.errors,
                name: 'CMServerErrorList',
                message: 'Server Error',
            };
        } else if ( error.request ) {
            return new Error('Error on request => Server does not respond' );
        } else {
            return new Error('Client error => ' + error.message);
        }
    }

    private static _checkTokenDelete(errors) {
        if(!errors) { return false; }
        const tError = errors.findIndex((elem) => {
            return elem.name === CM_INVALID_TOKEN || elem.name === CM_EXPIRED_TOKEN;
        });
        return tError !== -1;
    }

}